import { Navigate, Route, Routes } from "react-router-dom"
import { Layout } from "./components/Layout"
import { ClipGen } from "./pages/ClipGen"
import { Login } from "./pages/Login"
import { RunDetail } from "./pages/RunDetail"
import { RunsList } from "./pages/RunsList"
import { Settings } from "./pages/Settings"
import { SharedRun } from "./pages/SharedRun"
import { Submit } from "./pages/Submit"

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Phase 6 Stage C-D: 共有 URL (Layout 外、auth 不要) */}
      <Route path="/shared/:token" element={<SharedRun />} />
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/submit" replace />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/runs" element={<RunsList />} />
        <Route path="/runs/:runId" element={<RunDetail />} />
        {/* Phase 7 PR2: clip 生成 page (Figma 05) */}
        <Route path="/runs/:runId/clips/:rank" element={<ClipGen />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/submit" replace />} />
    </Routes>
  )
}

export default App
